// -----------------------------------------------------------------------------
// Persistenza locale (Fase 5) — solo localStorage, nessun backend/account.
// Chiavi del golden master: ft_best_score, ft_games_played, ft_accessibility.
// Lettura difensiva: valori mancanti/corrotti/non validi -> default, mai crash.
// -----------------------------------------------------------------------------

export const STORAGE_KEYS = {
  BEST_SCORE: "ft_best_score",
  GAMES_PLAYED: "ft_games_played",
  ACCESSIBILITY: "ft_accessibility",
};

function safeGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null; // localStorage non disponibile (es. Safari privato) -> default
  }
}

function safeSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false; // quota/privato: fallback silenzioso
  }
}

function toNonNegativeInt(raw) {
  if (raw === null || raw === undefined) return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return null; // NaN, "abc", -5, Infinity -> non valido
  return Math.floor(n);
}

// ---- Record personale --------------------------------------------------------
export function getBestScore() {
  return toNonNegativeInt(safeGet(STORAGE_KEYS.BEST_SCORE)) ?? 0;
}

export function setBestScore(score) {
  const n = toNonNegativeInt(score);
  if (n !== null) safeSet(STORAGE_KEYS.BEST_SCORE, String(n));
}

// Aggiorna il record se superato. Ritorna { best, isNewRecord }.
export function updateBestScore(score) {
  const current = getBestScore();
  const s = toNonNegativeInt(score);
  if (s !== null && s > current) {
    setBestScore(s);
    return { best: s, isNewRecord: true };
  }
  return { best: current, isNewRecord: false };
}

// ---- Partite giocate ---------------------------------------------------------
export function getGamesPlayed() {
  return toNonNegativeInt(safeGet(STORAGE_KEYS.GAMES_PLAYED)) ?? 0;
}

export function incrementGamesPlayed() {
  const next = getGamesPlayed() + 1;
  safeSet(STORAGE_KEYS.GAMES_PLAYED, String(next));
  return next;
}

// ---- Preferenza accessibilità (default: false) -------------------------------
export function getAccessibility() {
  const raw = safeGet(STORAGE_KEYS.ACCESSIBILITY);
  if (raw === "true") return true;
  if (raw === "false") return false;
  return false; // mancante/corrotto -> default
}

export function setAccessibility(enabled) {
  safeSet(STORAGE_KEYS.ACCESSIBILITY, enabled ? "true" : "false");
}
